export default __webpack_public_path__ + "static/media/sign_up_head.f236d426.png";